<template>
  <div class="yxtbiz-tutor-selector">
    <yxt-tabs
      v-if="setTabs.length > 1"
      @tab-click='tabClick'
      v-model='activeName'
      :drawer-top='drawerTop'
    >
      <yxt-tab-pane
        :key='index'
        v-for='(tab, index) in setTabs'
        :name='tab.value'
      >
        <span slot='label'>{{ tab.label }}</span>
      </yxt-tab-pane>
    </yxt-tabs>
    <!-- 选择人员 -->
    <yxtbiz-range-selector
      v-if="isSelectUser"
      ref="rangeSelector"
      class="yxtbiz-tutor-selector__pt10"
      v-model="users"
      :multiple="!singleMode"
      :model="'array'"
      :limit="singleMode ? 0 : limit"
      :functionCode="functionCode"
      :dataPermissionCode="selectUserPermissionCode"
      :tabs="['persons']"
      @change="changeFn"
    ></yxtbiz-range-selector>
    <div v-if="!isSelectUser" :class="setTabs.length > 1 ? 'yxtbiz-tutor-selector__pt10' : ''" class="yxtbiz-tutor-selector__range">
      <div class="yxtbiz-tutor-selector__range-main">
        <div class="yxtbiz-tutor-selector__range-main-content">
          <div class="yxtbiz-tutor-selector__container yxt-tutor-multi-container">
            <div class="yxtbiz-tutor-search-wrap">
              <select-popover
                class="mr12 yxtbiz-tutor-search-inlineb mb16"
                style="width: 144px"
                ref="selectPopover"
                size="small"
                is-dept
                :selectOpition="selectOpition"
              >
                <dept-tree
                  :functionCode="functionCode"
                  :dataPermissionCode="dataPermissionCode"
                  :filterable="true"
                  :visibleOrgSelector="false"
                  :targetOrgId="teSearch.orgId"
                  @nodeClick="nodeClick"
                ></dept-tree>
              </select-popover>
              <!-- 选择岗位 -->
              <yxt-select
                class='mr12 yxtbiz-tutor-search-inlineb mb16'
                v-model="posVal"
                :placeholder="$t('biz_udp_no_limit_pos')"
                icon-name="more"
                hidden-option
                collapse-tags
                style="width: 144px"
                size="small"
                value-key="key"
                prop-label="value"
                @visible-change="visiblePos=true"
              >
                <template slot='tag' slot-scope='{ data }'>
                  <span>{{ data.currentLabel }}</span>
                </template>
              </yxt-select>
              <yxt-drawer :title="$t('pc_biz_udp_tit_selectPotision')" :visible.sync="visiblePos" size="960px">
                <check-single-position ref="refPosition" :checkedPositions.sync="checkedPositions" @choose='handlePositionChoose'/>
              </yxt-drawer>
              <yxt-select
                v-model="catalogVal"
                size="small"
                class="mr12 yxtbiz-tutor-search-inlineb mb16"
                style="width: 144px"
                clearable
                :placeholder="$t('pc_biz_lbl_tutorcategory').d('导师分类')"
                @change="changeCatalog"
              >
                <yxt-option
                  v-for="item in catalogList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </yxt-select>
              <!-- 请输入姓名/账号搜索 -->
              <yxt-input
                class="yxtbiz-tutor-search-inlineb mb16"
                style="width: 178px"
                :placeholder="$t('pc_biz_te_tip_enternameaccountsearch')"
                v-model="teSearch.keyword"
                searchable
                size="small"
                maxlength="50"
                @search="teNameSearch"
              >
              </yxt-input>
            </div>
            <yxt-table
              ref="stb"
              class="yxt-tutor-table pr20"
              @select-all="selectAll"
              @select="select"
              v-loading="loading"
              :key="`t${renderCount}`"
              :data="teaList"
              :height="tableHeight"
            >
              <yxt-table-column
                v-if="!isSingle"
                :show-overflow-tooltip="false"
                class-name="yxtbiz-table-selection"
                type="selection"
                width="40"
              ></yxt-table-column>
              <yxt-table-column
                v-else
                :show-overflow-tooltip="false"
                class-name="yxtbiz-table-selection"
                width="40"
              >
                <template slot-scope="scope">
                  <yxt-radio v-model="singleSelect" @change="selectTea(scope.row)" :label="scope.row.id"></yxt-radio>
                </template>
              </yxt-table-column>
              <yxt-table-column
                width="18"
                align="right"
                clear-padding="left-right"
                v-if="!isSingle"
                >
                <template slot="header">
                  <yxt-dropdown placement="bottom-start" @command="tableHeaderCommand">
                      <span> </span>
                      <yxt-dropdown-menu slot="dropdown">
                        <yxt-dropdown-item command="selectCurrentData">{{$t('pc_biz_te_select_current_page').d('选择本页')}}</yxt-dropdown-item>
                        <yxt-dropdown-item command="selectAllData" >{{$t('pc_biz_te_select_all').d('选择全部')}}</yxt-dropdown-item>
                        <yxt-dropdown-item command="clearSelectData" >{{$t('pc_biz_te_clear_all').d('清空所选')}}</yxt-dropdown-item>
                      </yxt-dropdown-menu>
                  </yxt-dropdown>
                </template>
              </yxt-table-column>
              <!-- 讲师姓名/账号 -->
              <yxt-table-column
                :label="$t('pc_biz_te_lbl_tutornameaccount')"
                :show-overflow-tooltip='false'
              >
                <template slot-scope="scope">
                  <div class="yxtbiz-tutor-flex-center">
                    <yxt-tooltip effect="dark" placement="top" :open-filter="true">
                      <div slot="content">
                        <span
                        ><yxtbiz-user-name :name="scope.row.fullname" />{{
                            (scope.row.username && scope.row.username != '') ? `（${scope.row.username}）` : ''
                          }}</span
                        >
                      </div>
                      <div class="ellipsis nowrap">
                        <span
                        ><yxtbiz-user-name :name="scope.row.fullname" />{{
                            (scope.row.username && scope.row.username != '') ? `（${scope.row.username}）` : ''
                          }}</span
                        >
                      </div>
                    </yxt-tooltip>
                  </div>
                </template>
              </yxt-table-column>
              <!-- 部门 -->
              <yxt-table-column
                show-overflow-tooltip
                popover-html
                :label="$t('pc_biz_te_lbl_department')"
                prop="deptName"
                align="left"
              >
                <template slot-scope="scope">
                  <yxtbiz-dept-name
                    :name="scope.row.deptName || '--'"
                  /> </template
                ></yxt-table-column>
              <!-- 岗位 -->
              <yxt-table-column
                show-overflow-tooltip
                :label="$t('biz_udp_position')"
                prop="positionName"
                align="left"
              >
                <template slot-scope="scope">
                  {{ scope.row.positionName || '--' }}
                </template>
              </yxt-table-column>
              <template slot="empty">
                <div style="line-height: normal">
                  <yxt-empty
                    :empty-text="
                      activeName === 'certifiedLecturer'
                        ? $t(
                            'pc_biz_te_no_certification_lecturer' /*暂无认证讲师，您可以在讲师库选择其他讲师*/
                          )
                        : $t('pc_biz_lbl_nodata' /*暂无数据*/)
                    "
                  />
                </div>
              </template>
            </yxt-table>
            <div class="yxtbiz-tutor-selector__mask mt16 pr20">
              <yxt-pagination
                class="pull-right"
                :page-size="teSearch.limit"
                :total="count"
                :current-page="page"
                layout="total, prev, pager, next"
                @current-change="pageChange"
                @size-change="sizeChange"
              ></yxt-pagination>
            </div>
          </div>
        </div>
        <div class="yxtbiz-tutor-selector__checkedlist">
          <check-list :limit="limit" :checkedData="teDataUser" @change="selectedChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTeList, getCatalogList } from './service';
// import dateUtil from 'yxt-biz-pc/src/utils/date';
import resizeTable from '../../user-selector/mixins/resizeTable';
import UserName from 'yxt-biz-pc/packages/user-name';
import DeptName from 'yxt-biz-pc/packages/dept-name';
import { Table, TableColumn, Pagination, Link, Select, Option } from 'yxt-pc';
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
import SelectPopover from '../../check-person-range/src/components/SelectPopover.vue';
import deptTree from '../../dept-tree';
import checkSinglePosition from '../../check-single-position';
import CheckList from './components/checkList.vue';
export default {
  name: 'YxtbizTutorSelectorV2',
  name_zh: '导师组件选择V2',
  eventList: [
    {
      type: 'select', // 抛出的事件名
      handler: 'onChange', // 事件处理函数
      label: '点击选择后的事件' // 事件描述
    },
    {
      type: 'input', // 抛出的事件名
      handler: 'onChange', // 事件处理函数
      label: '点击选择后的事件' // 事件描述
    }
  ],
  components: {
    YxtbizUserName: UserName,
    YxtbizDeptName: DeptName,
    YxtTable: Table,
    YxtTableColumn: TableColumn,
    YxtPagination: Pagination,
    YxtLink: Link,
    YxtSelect: Select,
    YxtOption: Option,
    SelectPopover,
    deptTree,
    checkSinglePosition,
    CheckList
  },
  mixins: [resizeTable],
  props: {
    value: {
      type: Array | Object,
      default: () => {
        return {};
      },
      desc: '当前选择的对象',
      setter: 'JsonSetter'
    },
    // 是否可以有选人模式
    allowSelectUser: {
      type: Boolean,
      default: false,
      desc: '是否可以有选人模式',
      setter: 'BooleanSetter'
    },
    functionCode: {
      type: String,
      default: '',
      desc: '页面的导航编号',
      setter: 'StringSetter'
    },
    dataPermissionCode: {
      type: String,
      default: '',
      desc: '选导师的数据权限点',
      setter: 'StringSetter'
    },
    selectUserPermissionCode: {
      type: String,
      default: '',
      desc: '选人的数据权限点',
      setter: 'StringSetter'
    },
    // 是否包含所有类型的数据（禁用的）
    showAll: {
      type: Boolean,
      default: false,
      desc: '是否包含所有类型的数据（禁用的）',
      setter: 'BooleanSetter'
    },
    // 是否强制单选模式， 默认会根据传入的数据类型修改。true时强制单选模式
    singleMode: {
      type: Boolean,
      default: false,
      desc: '是否强制单选模式',
      setter: 'BooleanSetter'
    },
    // 导师对应UDP用户状态
    udpDisabled: {
      type: Number,
      default: -1,
      desc: '导师对应UDP用户状态',
      setter: 'NumberSetter'
    },
    // 增加表格是否可选参数
    selectable: {
      type: Function,
      default: () => true,
      desc: '增加表格是否可选参数',
      setter: 'JsonSetter'
    },
    drawerTop: {
      type: Boolean,
      default: false,
      desc: 'tab页签展示在抽屉顶部',
      setter: 'BooleanSetter'
    },
    maxLimit: {
      type: Number,
      default: 0,
      desc: '最大数量',
      setter: 'NumberSetter'
    }
  },
  data() {
    return {
      catalogVal: '',
      catalogList: [],
      teDataUser: [],
      singleSelect: '',
      limit: this.maxLimit,
      renderCount: 0,
      page: 1,
      refTable: 'stb',
      tableHeight: 0,
      teSearch: {
        catalogId: '',
        dataPermissionCode: this.dataPermissionCode,
        deptId: '', // 部门id
        disabled: -1,
        keyword: '',
        limit: 20,
        navCode: this.functionCode,
        offset: 0,
        positionId: ''
      },
      loaded: 1,
      loading: false,
      totalPage: 0,
      count: 0,
      teaList: [],
      selected: {},
      user: {},
      users: [],
      isSingle: true, // m2只有单选模式
      isSingleVal: true,
      isCanSelectUser: false,
      isSelectUser: false,
      setTabs: [
        {
          label: this.$t('pc_biz_te_lbl_tutor'),
          value: 'teacher'
        }
      ],
      activeName: 'teacher',
      teSelected: [],
      teData: [],
      selectOpition: {
        placeholder: i18n.t('pc_biz_te_dept' /* 选择部门 */),
        checkWord: ''
      },
      query: {
        showNoClassification: '',
        orgId: ''
      },
      visiblePos: false,
      posVal: { },
      checkedPositions: []
    };
  },
  computed: {
  },
  created() {
    this.isSingleVal =
      !this.value || (!this.value.length && this.value.length !== 0);
    this.isSingle = this.singleMode || this.isSingleVal;
    this.teData = this.value || [];
    if (Object.prototype.toString.call(this.value) === '[object Object]') {
      if (this.value.id) {
        this.teData = [this.value];
        this.singleSelect = this.value.id;
      } else {
        this.teData = [];
      }
    }
    // if (this.singleMode) {
    //   this.user = this.teData[0] || {};
    // }
    this.formatModel(this.value);
    this.initChooseType();
    this.getTeList();
    this.getCatalogList();
  },
  methods: {
    async validate() {
      if (this.isSelectUser) {
        const status = await this.$refs.rangeSelector.validate();
        return status;
      } else {
        if (this.limit && this.teDataUser && this.teDataUser.length > this.limit) {
          this.$alert(
            this.$t('pc_biz_select_msg_limit').d('已选数量超过限制，请检查'),
            this.$t('biz_tcm_limitnum', { x: this.limit }),
            {
              confirmButtonText: this.$t('biz_tcm_checkbtn'),
              type: 'error'
            }
          );
          return false;
        } else {
          return true;
        }
      }
    },
    selectedChange(deleteInfo) {
      this.singleSelect = '';
      if (deleteInfo.type === 'all') {
        this.clearSelectData();
      } else {
        this.deleteItem(deleteInfo.deleteItem);
      }
    },
    tableHeaderCommand(row) {
      this[row]();
    },
    selectCurrentData() {
      // 选择本页
      this.teaList.forEach(obj => {
        this.selected[obj.id] = obj;
      });
      this.outPut();
    },
    selectAllData() {
      // 选择所有
      this.LoadAll();
    },
    clearSelectData() {
      this.$refs['stb'].clearSelection();
      this.selected = [];
      this.teData = [];
      this.outPut();
    },
    async LoadAll() {
      this.teSearch.keyword = this.teSearch.keyword.trim();
      this.teSearch.disabled = this.showAll ? -1 : 0;
      this.teSearch.positionId = this.posVal.key;
      this.teSearch.udpDisabled = this.udpDisabled;
      this.loading = true;
      const limit = 1000;
      const reqCount = Math.ceil(this.count / limit); // 循环次数
      const reqArrs = []; // 请求数组
      for (let i = 0; i < reqCount; i++) {
        const params = Object.assign({}, this.teSearch, {
          limit: limit,
          offset: limit * i
        });
        reqArrs.push(params);
      }
      try {
        const results = await Promise.all(
          reqArrs.map(params => getTeList(params))
        );
        const dataSource = [];
        results.forEach(res => {
          dataSource.push(...res.datas);
        });
        // console.log(dataSource);
        // this.teaList = dataSource;
        dataSource.forEach(obj => {
          this.selected[obj.id] = obj;
        });
        this.outPut();
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    // 列表数据
    getTeList(isReset) {
      if (isReset) {
        this.page = 1;
        this.teSearch.offset = 0;
      }
      this.teSearch.keyword = this.teSearch.keyword.trim();
      this.teSearch.disabled = this.showAll ? -1 : 0;
      this.teSearch.positionId = this.posVal.key;
      this.teSearch.udpDisabled = this.udpDisabled;
      this.loading = true;
      getTeList(this.teSearch)
        .then(result => {
          this.teaList = result.datas;
          this.totalPage = result.paging.pages;
          this.count = result.paging.count;
          this.loaded--;
          this.loading = false;
          this.$nextTick(() => {
            this.setChecked();
          });
        })
        .catch(e => {
          this.loading = false;
          console.log(e);
        });
    },
    // 多选是否显示tab
    initChooseType() {
      this.isCanSelectUser = this.allowSelectUser;
      if (this.isCanSelectUser) {
        this.setTabs = [
          {
            label: this.$t('pc_biz_te_lbl_tutor'), // 导师
            value: 'teacher'
          },
          {
            label: this.$t('biz_te_user'), // 员工
            value: 'person'
          }
        ];
      }
    },
    teNameSearch() {
      this.teSearch.searchKey = this.teCatalogSearch;
      this.getTeList(true);
    },
    sizeChange(size) {
      this.teSearch.limit = size;
      this.getTeList(true);
    },
    pageChange(page) {
      this.page = page;
      this.teSearch.offset = (page - 1) * this.teSearch.limit;
      this.getTeList();
    },
    selectTea(item) {
      if (this.isSingleVal) {
        if (this.value && (!item || this.value.id === item.id)) {
          this.$emit('input', null);
          this.$emit('select', null);
          this.teData = null;
        } else {
          this.$emit('input', item);
          this.$emit('select', item);
          this.teData = item;
          this.singleSelect = item.id;
        }
      } else {
        // 兼容之前的多选模式的数组型数据源&& 不是选人场景不可以反选选人的值
        if (
          this.value.length > 0 &&
          (!item || this.value[0].id === item.id) &&
          !(item && item.isUser && !this.isSelectUser)
        ) {
          this.$emit('input', []);
          this.$emit('select', []);
          this.teData = [];
        } else {
          this.$emit('input', item ? [item] : []);
          this.$emit('select', item ? [item] : []);
          this.teData = item ? [item] : [];
        }
      }
    },
    selectUser() {
      if (this.user && this.user.id) {
        this.selectTea({
          id: this.user.id,
          fullname: this.user.fullname,
          isUser: true
        });
      } else {
        this.selectTea();
      }
    },
    getCatasOfTree(arrNew, pId, cataAll) {
      cataAll.forEach(cata => {
        if (cata.parentId === pId || (!pId && !cata.parentId)) {
          cata.label = cata.name;
          cata.children = [];
          this.getCatasOfTree(cata.children, cata.id, cataAll);
          arrNew.push(cata);
        }
      });
    },
    // 选择某个
    select(item, row) {
      let isAdd = item.some(v => {
        return v.id === row.id;
      });
      if (!isAdd) {
        delete this.selected[row.id];
      } else {
        this.selected[row.id] = row;
      }
      this.outPut();
    },
    // 全选
    selectAll(items) {
      let isAdd =
        items.filter(item => {
          return this.selectable(item);
        }).length !== 0;
      this.teaList.forEach(obj => {
        if (this.selectable(obj)) {
          if (!isAdd) {
            delete this.selected[obj.id];
          } else {
            this.selected[obj.id] = obj;
          }
        }
      });
      this.outPut();
    },
    // 删除已选择
    deleteItem(item) {
      delete this.selected[item.id];
      this.outPut();
    },
    outPut() {
      this.teSelected = Object.values(this.selected);
      let reArry = this.reduceFn([...this.teSelected]);
      if (this.isSingleVal && reArry.length === 0) {
        reArry = null;
      }
      // if (reArry.length > this.limit) {
      //   this.showLimitError();
      //   return;
      // }
      this.$emit('input', reArry);
      this.$emit('select', reArry);
      this.teData = reArry;
    },
    showLimitError() {
      this.$alert(
        this.$t('pc_biz_udp_msg_outRange'),
        this.$t('biz_tcm_limitnum', { x: this.limit }),
        {
          confirmButtonText: this.$t('biz_tcm_checkbtn'),
          type: 'error'
        }
      );
    },
    setChecked() {
      if (this.isSelectUser) {
        return;
      }
      this.teaList.forEach(obj => {
        if (this.selected.hasOwnProperty(obj.id)) {
          this.$refs['stb'].toggleRowSelection(obj, true);
          this.singleSelect = obj.id;
        } else {
          this.$refs['stb'] && this.$refs['stb'].toggleRowSelection(obj, false);
        }
      });
    },
    formatModel(v) {
      this.selected = {};
      if (v) {
        if (this.isSingle) {
          // 单选入参v也存在array类型
          if (Object.prototype.toString.call(v) === '[object Object]') {
            if (v.id) {
              this.selected[v.id] = v;
            }
          } else {
            v.forEach(obj => {
              this.selected[obj.id] = obj;
            });
          }
        } else {
          v.forEach(obj => {
            this.selected[obj.id] = obj;
          });
        }
      }
    },
    // tab切换后重新勾选上已选择的讲师
    tabClick() {
      this.catalogVal = '';
      this.teSearch.catalogId = '';
      this.singleSelect = '';
      this.selectOpition.checkWord = '';
      this.teSearch.deptId = ''; // 清空部门选项
      this.teSearch.keyword = '';
      if (this.activeName !== 'person') this.getTeList();
      this.isSelectUser = this.activeName === 'person';
      if (this.teData && this.teData.length > 0) {
        this.users = this.teData;
        // 切换到选人tab后，数据不一致清空user
        if (this.isSelectUser && this.user && this.user.id && this.teData[0].id !== this.user.id) {
          this.user = {};
        }
      } else {
        this.users = [];
        this.user = {};
      }
      this.formatModel(this.teData);
      this.$nextTick(() => {
        this.setChecked();
      });
    },
    // 选择员工
    changeFn(users) {
      this.teSelected = Object.values(this.selected);
      if (users && users.length > 0) {
        let listArry = [];
        users.forEach(e => {
          if (e && e.fullname) {
            listArry.push({
              id: e.id,
              fullname: e.fullname,
              isUser: true
            });
          }
        });
        let reArry = this.reduceFn([...listArry]);
        this.$emit('input', reArry);
        this.$emit('select', reArry);
        this.teData = reArry;
      } else {
        this.$emit('input', []);
        this.$emit('select', []);
        this.teData = [];
      }
    },
    // 数组根据ID去重
    reduceFn(arryData) {
      // return arryData;
      let obj = {};
      return arryData.reduce((item, next) => {
        obj[next.id] ? '' : (obj[next.id] = true && item.push(next || ''));
        return item;
      }, []);
    },
    // 选择部门
    nodeClick(a) {
      this.teSearch.deptId = a.id;
      this.selectOpition.checkWord = a.id ? a.name : '';
      this.$refs['selectPopover'].cancel();
      this.getTeList(true);
    },
    // 选择岗位
    handlePositionChoose(selectOption) {
      if (selectOption.length > 0) {
        this.posVal = {
          key: selectOption[0].id,
          value: selectOption[0].name
        };
      } else {
        this.posVal = { };
      }
      this.visiblePos = false;
      this.getTeList(true);
    },
    // 获取分类
    getCatalogList() {
      getCatalogList(1).then(res => {
        this.catalogList = res || [];
      });
    },
    changeCatalog() {
      console.log(this.catalogVal);
      this.teSearch.catalogId = this.catalogVal === '-1' ? '' : this.catalogVal;
      this.getTeList(true);
    }
  },
  watch: {
    teData(newval) {
      this.teDataUser = newval;
      if (this.isSingle && Object.prototype.toString.call(newval) === '[object Object]') {
        if (newval.id) {
          this.teDataUser = [newval];
        } else {
          this.teData = [];
        }
      }
    },
    activeName(newVal) {
      if (newVal) this.getTeList(true);
    },
    teaList() {
      this.renderCount++;
    },
    teCatalogSearch(val) {
      this.$refs.tree.filter(val);
    },
    value(v) {
      this.formatModel(v);
      this.setChecked();
    },
    user() {
      this.selectUser();
    }
  }
};
</script>
